//! DO NOT EDIT THIS FILE IT IS GENERATED USING:
// mgs generate-flags

// Description: Only show supplier portal to specific users during intial release.
// Default On Variation: true
// Default Off Variation: false
export const FF_PILOT_RELEASE = 'pilot_release';

// Description: Test flag as an example of a true/false flag
// Default On Variation: true
// Default Off Variation: false
export const FF_TEST_FLAG = 'test_flag';

// Description: Hide approvals on B2C orders from suppliers
// Default On Variation: true
// Default Off Variation: false
export const FF_SUPPLIER_HIDE_B2C_APPROVALS = 'supplier_hide_b2c_approvals';

// Description: Enables supplier portal exposing replenishment order items from Circuit not Leafio Classic
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_REPLENISHMENT_ORDERS_VIEW = 'enable_replenishment_orders_view';

// Description: When enabled the suppliers will be capable of accessing leafio classic orders through the new orders page.
// Default On Variation: true
// Default Off Variation: false
export const FF_EXPOSE_LEGACY_ORDERS = 'expose_legacy_orders';
